import React from "react"
import { Link } from "gatsby"
import Layout from "../components/layout/layout"
import SEO from "../components/layout/seo"

function Quizzes() {
  return (
    <Layout>
      <SEO title="Page two" />
      <h1>Hi from the second page</h1>
      <p>Welcome to page Quizzes</p>
      <Link to="/">Go back to the homepage</Link>
    </Layout>
  )
}

export default Quizzes
